/**
 * created by athukorala on 9/11/19
 */

import React, {Component} from 'react';
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import axiosVistitorTags from "../../../axios/axios_visitortag";
import * as common from "../../../const/Common/CommonFunc";
import {Col, Row} from "reactstrap";
import LabelDropdown from "../../../components/Dropdown/Dropdown/DrpDwn";
import {Button, Input} from "semantic-ui-react";
import './Super_ViewMeetingsReport.css'
import {DatePicker, Empty, Icon, Spin} from "antd";
import {MDBDataTable} from "mdbreact";
import moment from "moment";
import * as TableHeader from '../../../store/Reducer/DropDownConst'
import Super_ViewMeetingsReports_Visitors
  from "./Super_ViewMeetingsReports_Visitors/Super_ViewMeetingsReports_Visitors";
import Download from "../../../components/Button/DownloadbleButton";
import apiConfig from "../../../axios/axios_api_services";

const { RangePicker } = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends Component {
  state = {
    details: [],
    data: [],
    spin: true,
    coportate_id: 0,
    branch_id: 0,
    building_id: 0,
    floor_id: 0,

    branch_list: [],
    building_list: [],
    floor_list: [],
    visitor_identify: "",
    start_date: "",
    end_date: "",

    isViewVisitors: false,
    meeting:0
  };

  viewVisitorsHandler = (condition,id) => {
    this.setState({
      isViewVisitors: condition,
      meeting:id
    })
  };

  componentDidMount() {
    this.getAllDetails();
  }

  titleOnChange = name => (e, {value}) => {
    const {details, coportate_id, branch_id, building_id} = this.state;

    switch (name) {
      case "corporate":

        let branches = [];
        details.map((details, index) => {
          if (details.corporateId === value) {
            branches = details.branches
          }
        });

        this.setState({
          coportate_id: value,
          branch_list: branches,
          building_list: [],
          floor_list: [],
          branch_id: 0,
          building_id: 0,
          floor_id: 0,
        });
        break;
      case "branch":
        let buildings = [];
        details.map((details, index) => {
          if (details.corporateId === coportate_id) {
            details.branches.map((branch, index) => {
              if (branch.branchId === value) {
                buildings = branch.buildings;
              }
            })
          }
        });


        this.setState({
          branch_id: value,
          building_list: buildings,
          floor_list: [],
          building_id: 0,
          floor_id: 0,
        });
        break;
      case "building":
        let floors = [];
        details.map((details, index) => {
          if (details.corporateId === coportate_id) {
            details.branches.map((branch, index) => {
              if (branch.branchId === branch_id) {
                branch.buildings.map((building, index) => {
                  if (building.buildingId === value) {
                    floors = building.floors
                  }
                })
              }
            })
          }
        });


        this.setState({
          building_id: value,
          floor_list: floors,
          floor_id: 0,
        });
        break;
      case "floor":
        this.setState({
          floor_id: value
        });
        break;
      default:
        break;
    }
  };
  getAllDetails = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.CORPORATE_WITH_BRANCHES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            details: response.data.body
          });
          this.filterHandler();
        }else{
          this.setState({
            details: [],
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }
      });
  };

  handleChange = (name) => event => {
    let value = event.target.value;
    this.setState({
      [name]: value
    });
  };
  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      this.setState({
        start_date: start,
        end_date: end,
      })
    }
  };

  render() {
    // console.log("details", this.state.details);
    const {details, branch_list, building_list, floor_list} = this.state;

    let corporate_options = [{value: 0, text: "All"}];
    let branch_options = [{value: 0, text: "All"}];
    let building_options = [{value: 0, text: "All"}];
    let floor_options = [{value: 0, text: "All"}];

    if (details.length !== 0) {
      details.map((details, index) => {
        const obj = {
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }

    if (branch_list.length !== 0) {
      branch_list.map((details, index) => {
        const obj = {
          text: details.name,
          value: details.branchId
        };
        branch_options.push(obj)
      })
    }

    if (building_list.length !== 0) {
      building_list.map((details, index) => {
        const obj = {
          text: details.name,
          value: details.buildingId
        };
        building_options.push(obj)
      })
    }

    if (floor_list.length !== 0) {
      floor_list.map((details, index) => {
        const obj = {
          text: details.description,
          value: details.floor_id
        };
        floor_options.push(obj)
      })
    }
    let rows = [];
    if(this.state.data.length !== 0){
      this.state.data.map((data,index)=>{
        const obj = {
          _1:data.corporateName,
          _2:data.branchName,
          _3:data.buildingName,
          _4:data.floorName,
          _5:data.hostAName,
          _6:data.hostBName,
          _7:data.meetingPurpose,
          _8:data.receptionName,
          _9:data.scheduleDate,
          _10:<Button
            onClick={()=>this.viewVisitorsHandler(true,data.meetingId)}
            icon='users'
            className={"super-meeting-report-view-visitors-btn"}/>,
        };
        rows.push(obj);
      })
    }

    let data = {columns: TableHeader.superMeetingReport, rows: rows};

    return (
      <div>
        {
          this.state.isViewVisitors ?
            <Super_ViewMeetingsReports_Visitors closeModal={this.viewVisitorsHandler} id={this.state.meeting}/>:null
        }
        <Spin spinning={this.state.spin} delay={10}
              indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
        <Row>
          <Col>
            <LabelDropdown
              disabled={this.state.spin}
              tagText={"Select Corporate"}
              placeholder={"Select Corporate"}
              options={corporate_options}
              value={this.state.coportate_id}
              onChange={this.titleOnChange("corporate")}
            />
          </Col>
          <Col>
            <LabelDropdown
              disabled={this.state.spin}
              tagText={"Select Branch"}
              placeholder={"Select Branch"}
              options={branch_options}
              value={this.state.branch_id}
              onChange={this.titleOnChange("branch")}
            />
          </Col>
          <Col>
            <LabelDropdown
              disabled={this.state.spin}
              tagText={"Select Building"}
              placeholder={"Select Building"}
              options={building_options}
              value={this.state.building_id}
              onChange={this.titleOnChange("building")}
            />
          </Col>
          <Col>
            <LabelDropdown
              disabled={this.state.spin}
              tagText={"Select Floor"}
              placeholder={"Select Floor"}
              options={floor_options}
              value={this.state.floor_id}
              onChange={this.titleOnChange("floor")}
            />
          </Col>
          <Col>
            {/*<p className={"super-meeting-visitor-id-txt"}>Visitor Identity</p>*/}
            <label>Visitor Identity</label>
            <Input
              onChange={this.handleChange('visitor_identify')}
              disabled={this.state.spin}
              value={this.state.visitor_identify}
              style={{width: '100%'}}
              placeholder='Visitor Identify'/>
          </Col>

          <Col xs={12} className={"super-meeting-btn"}>
            <Row>
              <div className={"rangepicker-super-meeting-report"}>
                <RangePicker
                  className={"rangepicker-super-meeting-report_"}
                  size={"mini"}
                  defaultValue={[moment().subtract(7, "days"), moment().subtract(0, "days")]}
                  disabledDate={disabledDate}
                  format="YYYY-MM-DD"
                  onChange={this.onChange}
                  allowClear={false}
                />
              </div>
              <Col>
                <Button.Group className={"dual-btn-rangepicker-super-meeting-report"}>
                  <Button onClick={this.resetHandler} color={"grey"}>Reset</Button>
                  <Button.Or/>
                  <Button positive onClick={this.filterHandler}>Search Data</Button>
                </Button.Group>
              </Col>
            </Row>

          </Col>
        </Row>

        <Row>
          <Col>
            {
              this.state.data.length !== 0 ?
                <div className={"super-meeting-report-wrapper"}>
                  <Download right={true} data={this.state.data} filename={"tags-meeting-report.csv"} userType={"MEETING_ALL_REPORT"}/>
                    <MDBDataTable
                      searching={true}
                      searchLabel={"Search Meeting"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      // striped={true}
                      bordered
                      hover
                      data={data}/>
                </div>
                :<Empty description={"Records not found"} className={"empty-icon"}/>
            }
          </Col>
        </Row>
        </Spin>
      </div>
    );
  }

  resetHandler = () => {
    this.setState({
      coportate_id: 0, branch_id: 0, building_id: 0, floor_id: 0,data: [],
      branch_list: [], building_list: [], floor_list: [], visitor_identify: ""
    })
  };

  filterHandler = () => {
    const {coportate_id,branch_id,building_id,floor_id,visitor_identify,start_date,end_date} = this.state;

    this.setState({
      spin: true
    });
    let startDate = new Date().setDate(new Date().getDate()-7);
    let endDate = new Date().setDate(new Date().getDate());

    if(start_date !== "" && end_date !== ""){
      startDate = new Date(start_date).getTime();
      endDate = new Date(end_date).getTime();
    }

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    // let url =
    //   "startDate="+ startDate +
    //   "&endDate="+ endDate +
    //   "&corporateId="+coportate_id+
    //   "&branchId="+branch_id+
    //   "&buildingId="+building_id+
    //   "&floorId="+floor_id+
    //   "&visitorIdentity="+visitor_identify.trim();
    axiosVistitorTags.get(apiConfig.MEETING_REPORT({corporateId:coportate_id,branchId:branch_id,buildingId:building_id,floorId:floor_id,visitorIdentity:visitor_identify.trim(),startDate:startDate,endDate:endDate}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data:response.data.content,
            spin: false
          });
        }else{
          common.notifyMessage(response.data.message);
          this.setState({
            data: [],
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.filterHandler();
        }
      });
  };
}

export default App;
